module.exports = __webpack_public_path__ + "img/idcard_end.08914621.png";